module.exports = __webpack_public_path__ + "img/faming13.c1883fcc.png";